export const singleSegmentBorderPlugin = {
    id: "singleSegmentBorder",
    beforeUpdate(chart) {
        chart.data.datasets.forEach((dataset) => {
            const single = dataset.data.filter(Boolean).length === 1
            dataset.borderWidth = single ? 0 : 2
            dataset.borderRadius = single ? 0 : 5
        })
    },
}
